<script>
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default {
    inheritAttrs: false,
    name: 'tooltip-tab',
    components: { VTooltipWrapper },
    props: {
        tooltipText: String
    }
}
</script>

<template>
    <v-tooltip-wrapper tooltip-position="bottom">
        <template #activator="{ on, attrs }">
            <v-tab
                activeClass="tooltip-tab-active"
                :aria-label="tooltipText"
                v-bind="{...attrs, ...$attrs}"
                @click="$emit('click', $event)"
                v-on="{...on}">
                <slot />
            </v-tab>
        </template>
        {{ tooltipText }}
    </v-tooltip-wrapper>
</template>
